import { render, staticRenderFns } from "./ParticipantDocumentStatus.vue?vue&type=template&id=35c697fa&"
import script from "./ParticipantDocumentStatus.vue?vue&type=script&lang=js&"
export * from "./ParticipantDocumentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports